import { APP_BASE_HREF, isPlatformServer } from '@angular/common';
import { Inject, Injectable, LOCALE_ID, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { FAIRS_CONFIGURATION, FairsConfiguration } from '@planone/bau365/data-access-fair-data';
import { BOT_REGEX } from '@planone/bau365/util-restricted-access';
import { WindowRef } from '@planone/shared/util-browser-api';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root',
})
export class BauInsightsAuthenticatedGuard extends KeycloakAuthGuard {
  constructor(
    protected override readonly router: Router,
    protected readonly keycloak: KeycloakService,
    private windowRef: WindowRef,
    @Inject(APP_BASE_HREF) private baseHref: string,
    @Inject(LOCALE_ID) private locale: string,
    @Inject(FAIRS_CONFIGURATION) private fairsConfiguration: FairsConfiguration,
    @Inject(PLATFORM_ID) private platformId: string,
    @Inject(BOT_REGEX) private botRegex: RegExp
  ) {
    super(router, keycloak);
  }

  public async isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // Force the user to log in if currently unauthenticated.
    if (
      !this.authenticated &&
      route.params['fair_id'] !== this.fairsConfiguration.bauInsights &&
      !isPlatformServer(this.platformId) &&
      !this.botRegex.test(this.windowRef.nativeWindow.navigator.userAgent)
    ) {
      await this.keycloak.login({
        redirectUri: window.location.origin + this.baseHref + state.url,
        locale: this.locale,
      });
    }

    return true;
  }
}
